export interface FooterColumn {
  title: string;
  links: Array<{
    label: string;
    href: string;
  }>;
}

export interface ContactInfo {
  addressOne?: string;
  addressTwo?: string;
  phones?: string[];
  email?: string;
}

export interface SocialLink {
  name: string;
  url: string;
  icon: string;
}

export interface FooterProps {
  variant?: "one" | "two" | "three";
  className?: string;
  logo?: string;
  description?: string;
  contactInfo?: ContactInfo;
  columns?: FooterColumn[];
  socialLinks?: SocialLink[];
  showAppLinks?: boolean;
  appStoreLinks?: {
    ios?: string;
    android?: string;
  };
  backgroundColor?: string;
  textColor?: string;
  showBackground?: boolean;
}

export const footerData: FooterProps = {
  variant: "one",
  className: "",
  logo: "/assets/Images/logo/logo.webp",
  description: "Not just a perfume, an identity.",
  contactInfo: {
    addressOne: "Tripoli-Mina, Facing Baytouna Express",
    email:"sales@myperfume.group",
    phones: ["+961 81 389 098"],
  },
  columns: [
    {
      title: "Pages",
      links: [
        { label: "Home", href: "/" },
        { label: "All Products", href: "/products" },
        { label: "Your cart", href: "cart" },
        { label: "Your Tracking", href: "tracking" },
        // { label: "Contact Us", href: "contact" },
      ],
    },
  ],
  socialLinks: [
    {
      name: "Facebook",
      url: "https://www.facebook.com/myperfume.group",
      icon: "ph-facebook-logo",
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/myperfume.group",
      icon: "ph-instagram-logo",
    },
  ],
  showAppLinks: true,
  appStoreLinks: {
    ios: "https://www.apple.com/store",
    android: "https://play.google.com/store/apps?hl=en",
  },
  backgroundColor: "bg-white",
  textColor: "text-gray-900",
  showBackground: true,
};
